import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';

@Component({
  selector: 'abb-tooltip',
  standalone: true,
  imports: [OverlayModule, CommonModule],
  template: `
    <div
      class="text-abb-primary underline cursor-help"
      (mouseenter)="triggerEnter()"
      (mouseleave)="triggerLeave()"
      cdkOverlayOrigin
      #tooltipTrigger="cdkOverlayOrigin"
    >
      <ng-content select="[trigger]"></ng-content>
    </div>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="tooltipTrigger"
      [cdkConnectedOverlayOpen]="showOverlay()"
    >
      <div
        (mouseenter)="tooltipEnter()"
        (mouseleave)="tooltipLeave()"
        class="bg-abb-background shadow-md p-3 transition-all text-abb-font/90"
        [ngClass]="{
          'opacity-0 scale-95 -translate-y-5':
            !isOpen() || (transitioning() && isOpen()),
          'opacity-100 scale-100 translate-y-0': !transitioning() && isOpen()
        }"
      >
        <ng-content></ng-content>
      </div>
    </ng-template>
  `,
  styles: ``,
})
export class AbbTooltipComponent {
  isOpen = signal(false);
  transitioning = signal(false);
  showOverlay = computed(() => this.isOpen() || this.transitioning());
  timeout: ReturnType<typeof setTimeout> | undefined;
  isOnTooltip = signal(false);
  isOnTrigger = signal(false);
  isOnTooltipOrTrigger = computed(
    () => this.isOnTooltip() || this.isOnTrigger()
  );
  constructor() {}

  private startTimeout() {
    this.transitioning.set(true);
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.transitioning.set(false);
      this.isOpen.update((old) => !old);
      this.timeout = undefined;
    }, 150);
  }

  reevaluate() {
    requestAnimationFrame(() => {
      if (
        (this.isOnTooltipOrTrigger() && this.isOpen()) ||
        (!this.isOnTooltipOrTrigger() && !this.isOpen())
      ) {
        return;
      }
      if (!this.isOnTooltipOrTrigger()) {
        if (!this.isOpen()) {
          clearTimeout(this.timeout);
          this.timeout = undefined;
          this.transitioning.set(false);
        } else {
          this.startTimeout();
        }
      } else {
        if (this.isOpen()) {
          clearTimeout(this.timeout);
          this.timeout = undefined;
          this.transitioning.set(false);
        } else {
          this.startTimeout();
        }
      }
    });
  }

  tooltipEnter() {
    this.isOnTooltip.set(true);
    this.reevaluate();
  }
  tooltipLeave() {
    this.isOnTooltip.set(false);
    this.reevaluate();
  }
  triggerEnter() {
    this.isOnTrigger.set(true);
    this.reevaluate();
  }
  triggerLeave() {
    this.isOnTrigger.set(false);
    this.reevaluate();
  }
}
